/**
 * File track-scroll-depth.js.
 * Handles firing Segment events for scroll depth
 */

let scrollTwenty = false,
    scrollFourty = false,
    scrollSixty = false,
    scrollEighty = false,
    scrollOneHundred = false;

const getDepthThrottled = throttle(getDepth, 100);

function getScrollPercent() {
  const h = document.documentElement,
        b = document.body,
        st = 'scrollTop',
        sh = 'scrollHeight';
  return Math.ceil((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100);
}

function fireDepthEvent(depth) {
  const properties = {
    depth_percentage: depth
  };

  // Analytics SDK double fire
  if (typeof Track !== 'undefined' && Track.WebBrowserActivityTracked) {
    fireAnalyticsEvent(Track.WebBrowserActivityTracked, {
      unique_id: 'pre_enrollment_scroll_depth',
      activity_type: 'BROWSER_ACTIVITY_TYPE_SCROLL_DEPTH',
      activity_value: String(depth),
    });
  } else {
    console.warn('Track is not defined.');
  }

  return segmentTrackAndReturn('Scroll Depth', properties);
}

function throttle(callbackFn, limit) {
  let wait = false;
  return function () {
    if (!wait) {
      callbackFn.call();
      wait = true;
      setTimeout(function () {
        callbackFn.call();
        wait = false;
      }, limit);
    }
  }
}

function getDepth() {
  const scrollPercent = getScrollPercent();

  if (scrollPercent >= 20 && !scrollTwenty) {
    scrollTwenty = fireDepthEvent(20);
  }

  if (scrollPercent >= 40 && !scrollFourty) {
    scrollFourty = fireDepthEvent(40);
  }

  if (scrollPercent >= 60 && !scrollSixty) {
    scrollSixty = fireDepthEvent(60);
  }

  if (scrollPercent >= 80 && !scrollEighty) {
    scrollEighty = fireDepthEvent(80);
  }

  if (scrollPercent >= 100 && !scrollOneHundred) {
    scrollOneHundred = fireDepthEvent(100);

    if (!scrollOneHundred) {
      document.removeEventListener('scroll', getDepthThrottled);
    }
  }
}

// Init
document.addEventListener('DOMContentLoaded', getDepth);
document.addEventListener('scroll', getDepthThrottled);
